import React from "react";
import { IonButton } from "@ionic/react";
import {
  resetState,
  toggleRequestRestart,
  useGameDispatch,
} from "context/GameContext";
// Css
import classes from "./RestartGame.module.scss";

const RestartGame: React.FC = () => {
  const gameDispatch = useGameDispatch();

  const handleRestartGame = () => {
    resetState(gameDispatch);
    if (window.location.pathname !== "/home")
      window.location.pathname = "/home";
  };

  return (
    <div className={classes.container}>
      <h2 className={classes.title}>Leave Game</h2>
      <p className={classes.description}>
        are you sure you want to leave the game?
      </p>
      <div>
        <IonButton size="small" onClick={handleRestartGame}>
          leave
        </IonButton>
        <IonButton
          size="small"
          onClick={() => toggleRequestRestart(gameDispatch)}
        >
          cancel
        </IonButton>
      </div>
    </div>
  );
};

export default RestartGame;
